
import { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Avatar, Menu, MenuItem, Typography, ListItem, Button, ListItemText, ListItemIcon, CircularProgress, Box } from "@mui/material"

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";

import { logout } from "../store/slices/AuthSlice";
import { RootState } from "../store";

import { AvatarAppBarStyle, ListItembuttonStyle, ListItemIconStyle, ListSubItemStyle, ListTypographyStyle } from '../styles/ListItemStyle';

import { Logout } from "../connections/auth/AuthConnection";

export const ListItemPerfil = () => {

    const dispatch = useDispatch();

    const { nombres, apellidos, unidad, administrador } = useSelector( ( state: RootState ) => state.auth );

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [loading, setLoading] = useState(false);

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleLogout = async () => {

        setLoading( true );      

        await Logout().then( resp => {

            const { success } = resp;

            if( success ){

                setTimeout(() => {

                    localStorage.setItem('lastPath', '/' );
                    localStorage.clear();
                    
                    dispatch( logout() );
                    setLoading( false );
                
                }, 700);       

            }
            else {

                setTimeout(() => {
                    
                    setLoading( false );
                
                }, 700);  

            }

        });            

    }

    const open = Boolean(anchorEl);   

    return (
        
        <>
            <ListItem component="div" style={{ textAlign: 'right' }}> 

                <ListItemText style={ListItemIconStyle}>
                
                    <Button color="inherit" style={{ ...ListItembuttonStyle }} onClick={ handleOpenMenu } >

                        <Avatar 
                            alt="Mi Avatar"                             
                            style={AvatarAppBarStyle} 
                            src={ process.env.PUBLIC_URL + "/assets/profile.png" }
                        />
                        
                        <Box sx={{ textAlign: 'center', mx: 3, display: { xs: 'none', 'xl': 'block' } }} >

                            <Box sx={{ textAlign: 'center' }}>
                                <Typography variant="subtitle2" color="textSecondary">
                                    <strong>{ nombres?.toUpperCase() } { apellidos?.toUpperCase() }</strong>
                                </Typography>
                            </Box>
                           
                            <Box sx={{ textAlign: 'center' }}>
                                { 
                                    administrador 
                                    ? 
                                        <Typography variant="caption" fontSize={14}>( Administrador )</Typography> 
                                    :
                                        <Typography variant="caption">( { unidad } )</Typography> 
                                }
                            </Box>

                        </Box>

                        <KeyboardArrowDownIcon style={ ListItemIconStyle } />       

                    </Button>

                </ListItemText>

            </ListItem>

            <Menu elevation={ 4 } anchorEl={ anchorEl } anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} keepMounted open={ open } onClose={ handleCloseMenu }>  

                <MenuItem style={ ListSubItemStyle } onClick={ handleLogout } >

                    <ListItemIcon style={ ListItemIconStyle }>         

                        {
                            loading
                            ?
                                <CircularProgress size={20} />
                            :
                                <ExitToAppOutlinedIcon style={{ ...ListItemIconStyle, fontSize: 20 }} />  
                        }              

                    </ListItemIcon>

                    <ListItemText style={ListTypographyStyle}> Salir </ListItemText>   

                </MenuItem>    

            </Menu>  

        </>

    )
}